import { render, staticRenderFns } from "./subtitleIntro.vue?vue&type=template&id=c2705ce8&scoped=true&"
import script from "./subtitleIntro.vue?vue&type=script&lang=js&"
export * from "./subtitleIntro.vue?vue&type=script&lang=js&"
import style0 from "./subtitleIntro.vue?vue&type=style&index=0&id=c2705ce8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2705ce8",
  null
  
)

export default component.exports